import { AsyncPipe, NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { filter, fromEvent } from 'rxjs';
import { ModalService } from './modal.service';

@Component({
    selector: 'nexus-modal-container',
    imports: [NgComponentOutlet, AsyncPipe],
    templateUrl: './modal-container.component.html',
    styleUrl: './modal-container.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalContainerComponent {
  service = inject(ModalService);

  @ViewChild('modalElement') modalRef!: ElementRef;

  modal$ = this.service.getModal();
  currentModal$ = this.modal$.pipe(filter(m => !!m));

  bootstrapRef: any;

  ngAfterViewInit() {
    const bootstrap = (window as any).bootstrap;
    if(!bootstrap) return;
    this.bootstrapRef = new bootstrap.Modal(this.modalRef.nativeElement);

    this.modal$.subscribe(config => {
      if(config) {
        this.bootstrapRef?.handleUpdate();
        this.bootstrapRef?.show();
      } else {
        this.bootstrapRef?.hide();
      }
    });

    fromEvent(this.modalRef.nativeElement, 'hide.bs.modal').subscribe(() => this.service.close());
    fromEvent(this.modalRef.nativeElement, 'shown.bs.modal').subscribe(() => setTimeout(() => this.updateFocus()));
  }

  private updateFocus() {
    (document.querySelector('.modal [autofocus]') as HTMLElement)?.focus();

    if(!this.isTouchScreen()) {
      (document.querySelector('.modal [autofocusDesktop]') as HTMLElement)?.focus();
    }
  }

  private isTouchScreen() {
    return !!(('ontouchstart' in window) ||
       (navigator.maxTouchPoints > 0));
  }
}
